/**
 * @generated SignedSource<<8e5362dfb339a4a4f9eaa8cd701c38df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DepartmentAvailabilityHeaderFragment_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly id?: string;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"DepartmentAvailabilityFiltersModal_session">;
  readonly " $fragmentType": "DepartmentAvailabilityHeaderFragment_session";
};
export type DepartmentAvailabilityHeaderFragment_session$key = {
  readonly " $data"?: DepartmentAvailabilityHeaderFragment_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"DepartmentAvailabilityHeaderFragment_session">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DepartmentAvailabilityHeaderFragment_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DepartmentAvailabilityFiltersModal_session"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "Customer",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "Member",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "b1eb387d77a4fe5cf3fa2ad2ba56a7c6";

export default node;
